import Typography from "@mui/material/Typography";
export const TypeLabel = ({ field }) => {
  return <Typography variant="h6">{field.label}</Typography>;
};
